export default class ConfigModel{
        currentEnv : string = "DEV";
        carsimService_LOCAL : string = "";
        carsimService_DEV : string =  "https://devgateways.groups.local/carsimservicecore_gateway/CarSim";
        carsimService_QA : string = "";
        carsimService_PROD : string = "";
        translationService_LOCAL : string = "";
        translationService_DEV : string =  "";
        translationService_QA : string = "";
        translationService_PROD : string = "";
}